export default {
    EXOS_STAFF_NO: 'Staff No',
    EXOS_STAFF_BADGE_NO: 'Badge No',
    EXOS_STAFF_FULL_NAME: 'Staff Name',
};
